import Manager from 'coreClasses/Manager';
import {selectOpenedFlyoutIds, receiveOpenFlyouts} from 'coreStore/data/ui';

/**
 * Represents FlyoutsMgr
 */
class FlyoutsMgr extends Manager {
	/**
	 * Opens flyout multiple
	 * @param {String} flyoutId - Flyout id
	 * @param {Boolean} isSingle - True if flyout should be opened in single mode
	 * @returns {void}
	 */
	openFlyout(flyoutId: string, isSingle: boolean = false): void {
		const openedFlyoutIds = this.getOpenedFlyoutIds();
		const isOpened = this.isFlyoutOpened(flyoutId);

		if (isOpened || !flyoutId) {
			return;
		}

		if (isSingle) {
			this.setOpenedFlyoutIds([flyoutId]);

			return;
		}

		this.setOpenedFlyoutIds([...openedFlyoutIds, flyoutId]);
	}

	/**
	 * Closes all flyouts
	 * @returns {void}
	 */
	closeAllFlyouts(): void {
		this.setOpenedFlyoutIds([]);
	}

	/**
	 * Closes a flyout in multiple
	 * If the closed flyout is the first one, it is a parent, close all flyouts
	 * @param {String} flyoutId Flyout id
	 * @returns {void}
	 */
	closeFlyout(flyoutId: string): void {
		if (!this.isFlyoutOpened(flyoutId)) {
			return;
		}

		const openedFlyoutIds = this.getOpenedFlyoutIds();
		const index = openedFlyoutIds.indexOf(flyoutId);

		if (index === 0) {
			this.setOpenedFlyoutIds([]);
		} else {
			this.setOpenedFlyoutIds(openedFlyoutIds.slice(0, index));
		}
	}

	/**
	 * Toggles the flyout
	 * @param {String} flyoutId Flyout id
	 * @returns {void}
	 */
	toggleFlyout(flyoutId: string): void {
		if (this.isFlyoutOpened(flyoutId)) {
			this.closeAllFlyouts();
		} else {
			this.openFlyout(flyoutId, true);
		}
	}

	/**
	 * Checks if flyout is opened multiple
	 * @param {String} flyoutId Flyout id
	 * @returns {Boolean}
	 */
	isFlyoutOpened(flyoutId: string): boolean {
		return !!flyoutId && this.getOpenedFlyoutIds().includes(flyoutId);
	}

	/**
	 * Retrieves the list of opened flyout ids
	 * @returns {String[]}
	 */
	getOpenedFlyoutIds(): string[] {
		return selectOpenedFlyoutIds(this.managerRepository.getStoreMgr().getStore().getState());
	}

	/**
	 * Updates store with flyout information
	 * @param {String[]} openedFlyoutIds Flyout id to set in store
	 * @returns {void}
	 */
	private setOpenedFlyoutIds(openedFlyoutIds: string[] = []): void {
		this.managerRepository.getStoreMgr().getStore().dispatch(receiveOpenFlyouts(openedFlyoutIds));
	}
}

export default FlyoutsMgr;
